import { User } from "utils/types";
import client from "./client";

export const fetchMe = async (): Promise<User> => {
  return await client
    .get("/profiles/me")
    .then(response => response.data.response);
};

export const updateUser = async ({
  id,
  ...rest
}: Partial<User>): Promise<User> => {
  return await client
    .put(`/profiles/${id}`, {
      attributes: {
        ...rest
      }
    })
    .then(response => response.data.response);
};
